import React from "react";
import {
  Route,
  Switch,
  Redirect,
  withRouter,
} from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "./styles";

// components
import Header from "../Header";


// pages

import Apps from "../../pages/apps";
import feed from "../../pages/feed"; 


// context
import { useLayoutState } from "../../context/LayoutContext";

function Layout(props) {
  var classes = useStyles();

  // global
  var layoutState = useLayoutState();

  return (
    <div className={classes.root}>
        <>
          <Header history={props.history} />
          
          <div
            className={classnames(classes.content, {
              [classes.contentShift]: layoutState.isSidebarOpened,
            })}
          >
            <div className={classes.fakeToolbar} />
            <Switch>
              
              <Route path="/workpoint/feed" component={feed} />
              
              <Route path="/workpoint/setup" component={Apps} />
             
            </Switch>
          </div>
        </>
    </div>
  );
}

export default withRouter(Layout);
